import { ReactComponent as EditorLogoMarkIcon } from "core/assets/images/editor-logo-mark.svg";
import { colors } from "styles/colors";
import { styleAsClass } from "styles/styleAsClass";

const MARK_SIZE = 60;
const ICON_SIZE = 44;

const MARK = styleAsClass`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${String(MARK_SIZE)}px;
  height: ${String(MARK_SIZE)}px;
  border-radius: 50%;
  background-color: ${colors.GREY_900};
  box-shadow:
    0 0 0 1px #000 inset,
    0 1px 1px 0.5px rgba(255, 255, 255, 0.3) inset,
    0 6px 24px 0 rgba(27, 30, 34, 0.12);
  overflow: hidden;

  svg {
    width: ${String(ICON_SIZE)}px;
    height: ${String(ICON_SIZE)}px;
    display: block;
    flex-shrink: 0;
  }
`;

export function ClarkBrandMark({ className }: { className?: string }) {
  return (
    <div
      className={className ? `${MARK} ${className}` : MARK}
      role="img"
      aria-label="Clark AI"
    >
      <EditorLogoMarkIcon width={ICON_SIZE} height={ICON_SIZE} aria-hidden />
    </div>
  );
}

export const CLARK_BRAND_MARK_SIZE = MARK_SIZE;
